import InformationBox from '../../../../shared/information-box/InformationBox';
import informationIcon from './information-icon.svg?url';

export const UserDataInformation: React.FC<{ providerName: string }> = ({ providerName }) => {
  const title = `Kontakinformasjonen er hentet fra ${providerName}`;
  const infoText = `Vi har mottatt kontaktinformasjonen din fra ${providerName}. Ta kontakt med ${providerName} sin kundeservice dersom opplysningene ikke stemmer.`;
  return (
    <>
      <InformationBox icon={informationIcon} color="blue" title={title} infoText={infoText} />
    </>
  );
};
